import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Avatar,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import {
  IconBarbell,
  IconBuildings,
  IconChevronUp,
  IconHelpCircle,
  IconLogout,
  IconUser,
} from "@tabler/icons-react";
import { useUserStore } from "../stores/user";
import { formatRole } from "../helpers/format";

const UserConfigMenu = ({ middleMenu }: { middleMenu: boolean }) => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = () => {
    setAnchorEl(null);
    navigate("/");
  };

  const onMyGym = () => {
    setAnchorEl(null);
    navigate("/my-gym");
  };

  const onMyUser = () => {
    setAnchorEl(null);
    navigate("/my-user");
  };

  const onBranch = () => {
    setAnchorEl(null);
    navigate("/branches");
  };

  return (
    <>
      {middleMenu ? (
        <IconButton
          sx={{ backgroundColor: "secondary.light" }}
          onClick={handleClick}
        >
          <IconChevronUp size={18} />
        </IconButton>
      ) : (
        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
            gap: 1,
            justifyContent: "space-between",
            borderRadius: 5,
            padding: 1,
            backgroundColor: "secondary.light",
          }}
          onClick={handleClick}
        >
          <Stack sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}>
            <Avatar
              alt="student_avatar"
              src={user?.avatar}
              sx={{
                width: 30,
                height: 30,
              }}
            />
            <Stack>
              <Typography variant="body1" fontWeight={600}>
                {user?.name?.split(" ")[0]}
              </Typography>
              <Typography
                variant="body2"
                fontSize={12}
                color="secondary.contrastText"
              >
                {formatRole(String(user?.role))}
              </Typography>
            </Stack>
          </Stack>
          <IconChevronUp size={18} />
        </Stack>
      )}
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              borderRadius: 2,
              minWidth: { xs: 250, sm: 350 },
              p: { xs: 1.5, sm: 2 },
              mt: 1.5,
              ml: { xs: 2, sm: 5 },
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              // "&::before": {
              //   content: '""',
              //   display: "block",
              //   position: "absolute",
              //   top: 0,
              //   width: 12,
              //   height: 10,
              //   bgcolor: "background.paper",
              //   transform: "translateY(-50%) rotate(45deg)",
              //   zIndex: 0,
              // },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Stack sx={{ p: 2 }}>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Avatar
              alt="store_logo"
              src={user?.store?.logo}
              sx={{
                width: 30,
                height: 30,
              }}
            />
            <Typography variant="body1" fontWeight={600}>
              {user?.store?.name}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <MenuItem onClick={onMyGym} sx={{ paddingY: 1.5 }}>
          <ListItemIcon>
            <IconBarbell fontSize="small" />
          </ListItemIcon>
          Minha academia
        </MenuItem>{" "}
        {!user?.store?.parentCompanyId && (
          <MenuItem onClick={onBranch} sx={{ paddingY: 1.5 }}>
            <ListItemIcon>
              <IconBuildings fontSize="small" />
            </ListItemIcon>
            Minhas Filiais
          </MenuItem>
        )}
        <MenuItem onClick={onMyUser} sx={{ paddingY: 1.5 }}>
          <ListItemIcon>
            <IconUser fontSize="small" />
          </ListItemIcon>
          Meu usuário
        </MenuItem>{" "}
        <MenuItem
          sx={{ paddingY: 1.5 }}
          component="a"
          href="https://wa.me/551926260132?text=Preciso%20de%20suporte"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemIcon>
            <IconHelpCircle fontSize="small" />
          </ListItemIcon>
          Suporte
        </MenuItem>
        <MenuItem onClick={onLogout} sx={{ paddingY: 1.5, color: "red" }}>
          <ListItemIcon>
            <IconLogout fontSize="small" color="red" />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserConfigMenu;
